import { Controller } from "@hotwired/stimulus"

// Community lesson editor for creating and editing lessons.
// Handles TOML/JSON file upload and inline editing.

export default class extends Controller {
  static targets = ["fileInput", "preview", "form"]

  declare fileInputTarget: HTMLInputElement
  declare previewTarget: HTMLElement
  declare formTarget: HTMLFormElement

  triggerUpload(): void {
    this.fileInputTarget.click()
  }

  async handleFile(): Promise<void> {
    const file = this.fileInputTarget.files?.[0]
    if (!file) return

    if (file.name.endsWith(".toml") || file.name.endsWith(".json")) {
      const text = await file.text()
      this.previewTarget.textContent = text
      this.dispatch("fileLoaded", { detail: { name: file.name, content: text } })
    } else {
      this.previewTarget.textContent = "Unsupported file format. Use .toml or .json"
    }
  }

  async submitLesson(event: Event): Promise<void> {
    event.preventDefault()
    const formData = new FormData(this.formTarget)

    const file = this.fileInputTarget.files?.[0]
    if (file) {
      // Flat param name: the server no longer nests fields under `lesson[...]`
      // the way Rails' form_with did. See docs/cloudflare/migration.md.
      formData.append("source_file", file)
    }

    const response = await fetch(this.formTarget.action, {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRF-Token": this.csrfToken(),
        Accept: "text/vnd.turbo-stream.html",
      },
    })

    if (response.ok) {
      this.dispatch("submitted")
    }
  }

  private csrfToken(): string {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? ""
  }
}
